import { render, staticRenderFns } from "./timesheet-app.vue?vue&type=template&id=4b89ee42&"
import script from "./timesheet-app.ts?vue&type=script&lang=ts&"
export * from "./timesheet-app.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports